'use strict';

angular.module('atex.dam').directive('damFieldsList', ['DamService', function (DamService) {
  return {
    require: '^ngModel',

    scope: {
      model: '=ngModel',
      selectPresetCallBack : '&',
      flat:'='
    },

    controller: function ($scope) {

    },

    link: function (scope, element, attrs, ngModel) {
      $(element).select2({
        minimumInputLength: 2,

        formatInputTooShort: function () {
          return "Please enter 2 or more characters";
        },

        formatSelection: function(object, container) {
          return object.text;
        },

        query: _.debounce(function(query) {
          var solrQuery = query.term;
          DamService.autocomplete(solrQuery, attrs.field).then(function(terms) {
            var tags = [];
            if (terms && terms.length > 0) {
              terms.forEach(function(term) {
                tags.push({
                  id: term,
                  text: term
                });
              });
            }

            return query.callback({ more: false, results: tags });
          }).then(undefined, function(error) {
            console.log(error);
            return query.callback({ more: false, results: [] });
          });
        }, 200),

        tags: function () {
          return [];
        },

        placeholder: attrs.title,

        formatNoMatches: function () {
          return '';
        },
        containerCss: {
          "width": "100%",
          "margin-bottom": "5px"
        }
      });

      ngModel.$render = function (value) {
        var entries = angular.copy(ngModel.$viewValue) || [];

        var tags = [];
        entries.forEach(function (entry) {
          if(scope.flat) {
            entry = {id:entry, text:entry};
          }

          tags.push({id: entry.id, text: entry.id});
        });

        element.select2('data', tags);
      };

      element.on('change', function (event) {
        var objects = angular.copy(element.select2('data'));

        var values = [];
        objects.forEach(function (object) {
          if(scope.flat) {
            object = object.id;
          }
          values.push(object);
        });

        scope.$apply(function () {
          ngModel.$setViewValue(values);
        });

        if (scope.selectPresetCallBack) {
          scope.selectPresetCallBack();
        }
      });
   }
  };
}]);